var map = {
	"./1.png": 1726,
	"./2.png": 1727,
	"./3.png": 1728,
	"./4.png": 1729,
	"./5.png": 1730,
	"./Blog.svg": 1731,
	"./Blog.webp": 1732,
	"./ContactUs.png": 1733,
	"./ContactUsicon.png": 1734,
	"./Help.webp": 1735,
	"./Location.svg": 1736,
	"./Question.svg": 1737,
	"./Search.webp": 1738,
	"./Video.svg": 1739,
	"./facebook.svg": 1740,
	"./header.svg": 1574,
	"./instagram.svg": 1741,
	"./linkedin.svg": 1742,
	"./mail.svg": 1575,
	"./map-m.svg": 1743,
	"./map.svg": 1744,
	"./person.svg": 1576,
	"./phone.svg": 1430,
	"./pointer.svg": 1577,
	"./support.svg": 1578,
	"./telegram.svg": 1745,
	"./ticket.svg": 1579,
	"./twitter.svg": 1746,
	"./youtube.svg": 1747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2514;